<template>
    <div class="info-event-list section">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <div class="grid--row info-event-list--mobile-filter">
            <div class="grid--col info-event-list--mobile-filter-col">
                <cmp-dropdown-filter></cmp-dropdown-filter>
            </div>
        </div>

        <div class="info-event-list--courses">
            <cmp-info-event-item class="info-event-list--course section"
                    v-for="(course, courseIdx) in filteredCourses"
                    :key="course.name"
                    :course="course"
                    :is-highlighted="filter.val !== filterKeywords.all"
                    :general-labels="fetchGeneralLabels()">
            </cmp-info-event-item>
        </div>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import { mapActions, mapGetters } from 'vuex';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [cmsPlugin],
        computed: {
            ...mapGetters(['filter']),
            filterKeywords() {
                return get(this, 'content.course_filter.keywords', {});
            },
            filteredCourses() {
                return this.content.course_list
                    .filter(course => {
                        return [course.id, this.filterKeywords.all].includes(this.filter.val);
                    });
            },
        },
        methods: {
            ...mapActions(['setFilterData', 'setFilterValue']),
            fetchGeneralLabels() {
                return {
                    collapse: this.content.collapse_label,
                    expand: this.content.expand_label,
                    noEvents: this.content.no_events_label,
                };
            },
        },
        watch: {
            'content.course_filter': {
                handler(val) {
                    if (!val) {
                        return;
                    }

                    this.setFilterData(val);
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?f38df502